import { default as React, useEffect } from 'react';
import styled from 'styled-components/native';

import { useNavigation } from '@react-navigation/core';
import { StackNavigationProp } from '@react-navigation/stack';

import DynamicForm from '../../dynamic-forms/DynamicForm';
import DynamicFormProvider from '../../dynamic-forms/DynamicFormProvider';
import { useGetFormTemplate } from '../../dynamic-forms/hooks/useGetFormTemplate';

const CreateStudyScreen: React.FC = () => {
  const navigation = useNavigation<StackNavigationProp<any>>();
  const { formTemplate, getFormTemplate } = useGetFormTemplate('Create Study');
  useEffect(() => getFormTemplate(), [getFormTemplate]);

  // const [formValues, setFormValues] = useState<{ category: string }>({
  //   category: ''
  // });

  return (
    <DynamicFormProvider
      entitySchema={formTemplate?.entity}
      formStateNode={formTemplate?.config}
    >
      <DynamicForm
        // values={formValues}
        onChange={formValues => {
          // setFormValues(formValues as any);
          // console.log('onChange formValues', formValues);
        }}
      >
        {/* <StyledButton
          outlined
          inverse
          size='small'
          disabled={!formValues.category}
          onPress={() => {
            switch (formValues.category) {
              case StudyCategory.Sleep:
                navigation.navigate('StudiesNav', {
                  screen: 'CreateSleepStudy'
                });
                break;
              default:
                navigation.navigate('StudiesNav', {
                  screen: 'StudyComingSoon',
                  params: {
                    category: formValues.category
                  }
                });
            }
          }}
        >
          Save &amp; Continue
        </StyledButton> */}
      </DynamicForm>
    </DynamicFormProvider>
  );
};

export default CreateStudyScreen;
